import { AsyncPipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { selectIsInAemPreviewMode } from 'src/app/store/common/common.selectors';

import { LazyComponentId } from '../../services/lazy-components/lazy-components-registry';
import { ErrorPageComponent } from '../error-page/error-page.component';

@Component({
  selector: 'cc-app-routing-error',
  templateUrl: './app-routing-error.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, ErrorPageComponent, AsyncPipe]
})
export class AppRoutingErrorComponent {
  public readonly showAppPlaceholder$: Observable<boolean> = this.store.select(selectIsInAemPreviewMode);

  public readonly appPlaceholderComponent = LazyComponentId.AppPlaceholder;

  public constructor(private readonly store: Store) {}
}
